export enum UserSettingDefinitionTypes {
    expectedGoals = 'expectedGoals',
    goalieSituation = 'goalieSituationxGValues',
    pptContainerExpanded = 'pptContainerExpanded'
}

export interface UserSettingDefinition {
    id: string;
    name: string;
    type: UserSettingDefinitionTypes;
}

export interface UserSetting {
    id: string | UserSettingDefinitionTypes;
    value: string | boolean;
    updatedOn?: string;
    source?: string;
}

export interface SelectedShadowLineage {
    requested: string;
    userSettings: UserSettings;
    default: ShadowType;
}

export interface UserSettings {
    cookie: string;
    company: string;
    user: string;
}

export interface Shadow {
    shadowName: string;
    label: string;
}

export enum ShadowType {
    aaxg = 'AAxG',
    onxg = 'ONxG',
    includeEmptyNetSituations = 'Include Empty Net Situations',
    excludeEmptyNetSituations = 'Exclude empty net Situations',
}

export interface VirtualMetric {
    selectedShadow: ShadowType;
    selectedShadowLineage: SelectedShadowLineage;
    shadows: Shadow[];
}

export interface VirtualMetrics {
    expectedGoals: VirtualMetric;
    goalieSituationxGValues: VirtualMetric;
}

export interface VirtualMetricsAPIModel {
    virtualMetricsEnums: VirtualMetrics;
}

export interface UserSettingsStateModel {
    virtualMetrics: VirtualMetricsAPIModel;
    userSettingDefinitionsByName: Record<string, UserSettingDefinition>;
    userSettingsById: Record<string, UserSetting>;
}

export const userSettingsStateDefault: UserSettingsStateModel = {
    virtualMetrics: undefined,
    userSettingDefinitionsByName: undefined,
    userSettingsById: undefined,
};
